import { tramosFromHorario, tramoDefecto } from "@/components/HorarioTramosEditor";
import { modoConfigDefecto } from "@/components/HorarioModoConfig";
import { modoConfigFromHorario } from "@/lib/horarioModos";

export function horarioEditableDesdeOrigen(h) {
  if (!h) {
    return { tramos: [tramoDefecto()], modoConfig: modoConfigDefecto() };
  }
  return {
    tramos: tramosFromHorario(h),
    modoConfig: modoConfigFromHorario(h),
  };
}

export function horarioDepartamento(departamentos, depId) {
  if (!depId || depId === "none") return null;
  const dep = (departamentos || []).find((d) => d.id === Number(depId));
  if (!dep) return null;
  return dep.horario_efectivo || dep.horario || null;
}
